"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = shallowEqualObjects;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function shallowEqualObjects(objA, objB) {
  var allowedObjectKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];
    var aVal = objA[key];
    var bVal = objB[key];

    if (allowedObjectKeys.indexOf(key) !== -1) {
      return shallowEqualObjects(aVal, bVal);
    }

    if (_typeof(aVal) === 'object') {
      throw new Error('shallowEqualObjects can only compare objects whose values are primitives or functions, unless you allow for an object value with the allowedObjectKeys argument');
    }

    if (aVal !== bVal) {
      return false;
    }
  }

  return true;
}